import axios from 'axios'
import _ from 'lodash'

// state
const state = {
	activeHeaderTab: '',
	activeHeaderDisplayName: '',
	activeRequestsTab: '',  // Request Details and View Requests Tabs.
	activeRequestInfoTab: '',   // Request Info vs New Requests
	//activeInfoName: '',
	activeInfoDisplay: '--',  // Needs to be set
	//sessionExpired: false,
	activeInfoButton: 'options',
	userSelectTableRow: false,
	newRequestSelected: false,
	showViewRequests: true,
	scrollTop: false,
}

const getters = {
	getActiveInfoDisplay(state){
		return state.activeInfoDisplay
	}

}


// mutations
const mutations = {
	// Mutator for value variables
	SET_VARIABLE(state, payload) {
		const { key, value } = payload;
		if (state.hasOwnProperty(key)) {
			state[key] = value;
		}
		
		switch(key){
			case 'activeRequestInfoTab':
				sessionStorage.setItem("ACTIVE-REQUESTS-TAB", value);
				break;
			case 'activeRequestsTab':
				sessionStorage.setItem("ACTIVE-REQUESTS-INFO-TAB", value);
				break;
			case 'activeInfoDisplay':
				sessionStorage.setItem("ACTIVE-INFO-DISPLAY", value);
				break;
			case 'activeInfoButton':
				sessionStorage.setItem("ACTIVE-INFO-BUTTON", value);
				break;
			case 'activeHeaderTab':
				sessionStorage.setItem("ACTIVE-HEADER-TAB", value);
				break;
			case 'activeHeaderDisplayName':
				sessionStorage.setItem("ACTIVE-HEADER-DISPLAY-NAME", value);
				break;
		}
	},
}

// actions
const actions = {
	// Action for value variables
	setVariables({ commit }, payload) {
		commit('SET_VARIABLE', payload);
	},

	clear({commit}){
		// show View Requests
		commit('TOGGLE_BOOLEAN_STATE', {key: 'showViewRequests', bool: true});
	}
}

export default {
    namespaced: true,
	state,
	getters,
	mutations,
	actions
}